import React from 'react';
import { connect } from 'react-redux';
import { updateQueryString } from 'services/router/actions';
import RoleModal from 'components/RoleModal';
import { ADMIN, MANAGER } from 'components/RoleGate/constants';
import { Button, Form, Grid, Modal } from 'semantic-ui-react';
import { requestedSubmitSpraySubmission } from 'services/spraySubmission/actions';
import { SpraySubmissionId } from 'services/spraySubmissions/types';
import SubmittingButton from 'components/SubmittingButton';
import { SPRAY_SUBMISSION_SUBMIT_NAMESPACE } from 'services/spraySubmission/constants';

interface OwnProps {
    spraySubmissionId: SpraySubmissionId;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestSubmit: typeof requestedSubmitSpraySubmission;
}

type Props = OwnProps & DispatchProps;

export const SPRAY_SUBMISSION_CONFIRMATION_MODAL = 'spraySubmissionConfirmationModal';

export class SpraySubmissionConfirmationModalComponent extends React.PureComponent<Props> {
    handleOnClose = (): void => {
        const { ...props } = this.props;

        props.updateQueryString({ [SPRAY_SUBMISSION_CONFIRMATION_MODAL]: undefined });
    }

    handleOnSubmit = (): void => {
        const { spraySubmissionId, ...props } = this.props;
        props.requestSubmit(spraySubmissionId);
    }

    render(): React.ReactElement {
        return (
            <RoleModal requiredRoles={[ADMIN, MANAGER]} param={SPRAY_SUBMISSION_CONFIRMATION_MODAL}>
                <React.Fragment>
                    <Modal.Header>
                        Re-submit spray submission
                </Modal.Header>
                    <Modal.Content>
                        <Form onSubmit={this.handleOnSubmit}>
                            <Grid>
                                <Grid.Column width={16}>
                                    Are you sure you want to re-submit this?
                            </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Button
                                        type="button"
                                        color="grey"
                                        onClick={this.handleOnClose}
                                        fluid
                                        basic
                                        primary
                                    >
                                        Cancel
                                </Button>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmittingButton type="submit" primary fluid namespace={SPRAY_SUBMISSION_SUBMIT_NAMESPACE}>
                                        Confirm
                                </SubmittingButton>
                                </Grid.Column>
                            </Grid>
                        </Form>
                    </Modal.Content>
                </React.Fragment>
            </RoleModal>
        );
    }
}

export default connect(
    null,
    {
        updateQueryString,
        requestSubmit: requestedSubmitSpraySubmission
    }
)(SpraySubmissionConfirmationModalComponent);
